const filters = {
    id: null,
    busca: null,
    status: null,
    active: null,
}

export default filters
